import React from 'react';
import { Box, Typography } from '@mui/material';

// The site's page-opening block. Modules use this rather than restating the
// brand tokens, so a project folder never hardcodes what the eyebrow looks like.
const PageHeader = ({ eyebrow, title, intro, sx }) => (
    <Box sx={sx}>
        <Typography variant="h6" sx={{ mb: 2, color: 'secondary.main' }}>{eyebrow}</Typography>
        <Typography variant="h1" gutterBottom>{title}</Typography>
        {intro && (
            <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 600 }}>{intro}</Typography>
        )}
    </Box>
);

export default PageHeader;
